import { useState } from "react";
import { Box, Typography, useMediaQuery } from "@mui/material"
import TuneIcon from '@mui/icons-material/Tune';
import NutritionFilterForm from "../NutritionFilterForm";

const NutritionFilterDropdown = ({ label, setOpenFilterNav, type, categories = [] }) => {
  const sm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [showDropdown, setShowDropdown] = useState(false)

  const handleClickFilter = () => {
    if (!sm) {
      setShowDropdown(!showDropdown)
    } else {
      setOpenFilterNav(true)
    }
  }

  return (
    <Box
      sx={{
        position: 'relative'
      }}
    >
      <Box
        sx={{
          minWidth: '48px',
          height: '40px',
          borderRadius: '8px',
          border: '1px solid',
          borderColor: "primary.mediumGray",
          bgcolor: 'white',
          boxShadow: '0px 2px 10px 0px #5B87EF33',
          ml: '8px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px 12px',
          whiteSpace: 'nowrap'
        }}
        onClick={handleClickFilter}
      >
        <TuneIcon
          sx={{
            fontSize: '16px'
          }}
        />
        <Typography
          variant="body"
          sx={{
            display: { xs: 'none', md: 'block' },
            ml: '8px'
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          display: { xs: 'none', md: showDropdown ? 'block' : 'none' },
          position: 'absolute',
          top: '50px',
          right: 0,
          bgcolor: 'white',
          borderRadius: '16px',
          maxWidth: '390px',
          boxShadow: '0px 2px 20px 0px #5B87EF66',
          zIndex: '10'
        }}
      >
        <NutritionFilterForm label={label} onClose={() => setShowDropdown(false)} type={type} categories={categories} />
      </Box>
    </Box>
  )
}

export default NutritionFilterDropdown